'use client';

import { Button } from '@/components/primitives/Button';
import {
  GA_CTA_ID,
  GA_CTA_PLACEMENT,
  GA_EVENTS,
  GA_PARAMS,
} from '@/constants/analytics';
import {
  PROSE_BLOCK_ACTION_PROPS,
} from '@/constants/proseBlockReveal';
import { trackEvent } from '@/lib/analytics/trackEvent';

import styles from './Conclusion.module.css';

type ConclusionActionsProps = {
  downloadUrl: string;
  downloadLabel: string;
  supportUrl: string;
  supportLabel: string;
};

export function ConclusionActions({
  downloadUrl,
  downloadLabel,
  supportUrl,
  supportLabel,
}: ConclusionActionsProps) {
  return (
    <div className={styles.actions}>
      <Button
        href={downloadUrl}
        variant="primary"
        size="large"
        colour="blue"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          trackEvent(GA_EVENTS.ctaClick, {
            [GA_PARAMS.ctaId]: GA_CTA_ID.downloadReport,
            [GA_PARAMS.placement]: GA_CTA_PLACEMENT.conclusion,
          });
        }}
        {...PROSE_BLOCK_ACTION_PROPS}
      >
        {downloadLabel}
      </Button>
      <Button
        href={supportUrl}
        variant="primary"
        size="large"
        colour="blue"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          trackEvent(GA_EVENTS.ctaClick, {
            [GA_PARAMS.ctaId]: GA_CTA_ID.support,
            [GA_PARAMS.placement]: GA_CTA_PLACEMENT.conclusion,
          });
        }}
        {...PROSE_BLOCK_ACTION_PROPS}
      >
        {supportLabel}
      </Button>
    </div>
  );
}
